import { Buffer } from "buffer";

type JWT = {
  sub: string;
  "cognito:groups": string[];
  iss: string;
  version: number;
  client_id: string;
  origin_jti: string;
  event_id: string;
  token_use: string;
  scope: string;
  auth_time: number;
  auth_time_date: Date;
  exp: number;
  exp_date: Date;
  iat: number;
  iat_date: Date;
  jti: string;
  username: string;
  lifespan: number;
};

export const decode = (token: string | null): JWT | null => {
  if (!token) {
    return null;
  }

  const parts = token.split(".");

  const buffPart0 = Buffer.from(parts[0], "base64");
  const payloadPart0 = JSON.parse(buffPart0.toString("ascii"));
  const buffPart1 = Buffer.from(parts[1], "base64");
  const payloadPart1 = JSON.parse(buffPart1.toString("ascii"));

  if (!payloadPart0 || !payloadPart1 || !payloadPart1["exp"]) {
    return null;
  }

  const exp_date = new Date(0);

  if (!payloadPart1["cognito:groups"]) {
    payloadPart1["cognito:groups"] = [];
  }

  if (payloadPart1["exp"]) {
    exp_date.setUTCSeconds(payloadPart1["exp"]);
  }

  const auth_time_date = new Date(0);

  if (payloadPart1["auth_time"]) {
    auth_time_date.setUTCSeconds(payloadPart1["auth_time"]);
  }

  const iat_date = new Date(0);

  if (payloadPart1["iat"]) {
    iat_date.setUTCSeconds(payloadPart1["iat"]);
  }

  const lifespanPart: any = {};

  if (payloadPart1["exp"]) {
    const expirationTimeInSeconds = payloadPart1["exp"];
    const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    const remainingTimeInSeconds =
      expirationTimeInSeconds - currentTimeInSeconds;
    lifespanPart["lifespan"] = remainingTimeInSeconds;
  }

  return {
    ...payloadPart0,
    ...payloadPart1,
    exp_date,
    auth_time_date,
    iat_date,
    ...lifespanPart,
  };
};

export const isTokenValid = (token: string | null): boolean => {
  if (!token) {
    return false;
  }

  const payload = decode(token);

  if (!payload) {
    return false;
  }

  const expirationDate = payload["exp_date"];
  return Date.now() < expirationDate.getTime();
};
